<template>
  <div class="subscription-details">
    <div class="price">
      <div class="month-price" v-if="unit === 'year'">${{ monthPrice }}</div>
      <div class="price-details">
        <div v-if="unit === 'year'">/MONTH*</div>
        <div>Billed ${{ price }} {{ intervalType }}</div>
      </div>
    </div>
    <div class="benefits">
      <div class="benefit" v-for="benefit in benefits" :key="benefit">
        <img src="@/assets/images/icons/check_green.svg" alt="benefit" />
        <span v-html="benefit"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { GET_BENEFITS_V2 } from "@/constants/membership.js"
export default {
  computed: {
    ...mapGetters("Store", [
      "selectedProduct",
      "maxDiscount",
      "trialRecurringInterval",
      "subscriptionInterval",
      "trialType",
      "subscriptionType",
      "subscriptionOptions",
    ]),
    ...mapGetters("Optimizely", ["optimizelyData"]),
    unit () {
      return this.subscriptionInterval.interval_type
    },
    intervalType () {
      return this.subscriptionType
    },
    price () {
      if (this.subscriptionOptions[0]) {
        return this.subscriptionOptions[0].product.billing_details.regular.price
          .amount
      } else {
        return 96
      }
    },
    monthPrice () {
      try {
        return (
          this.selectedProduct.billing_details.regular.price.amount / 12
        ).toFixed(2)
      } catch (error) {
        return "-"
      }
    },

    sessions () {
      const product = this.selectedProduct
      const perks = [...(product.initial_perks || []), ...(product.perks || [])]
      let points = 0
      for (let perk of perks) {
        if (perk.identifier === "pg_points") {
          points += perk.amount
        }
      }
      return Math.floor(points / 1000)
    },
    benefits () {
      return GET_BENEFITS_V2({ percentDiscount: this.maxDiscount })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";
.subscription-details {
  color: #3b3b3b;
  margin-top: 1rem;
  .price {
    padding: 0 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;
    .month-price {
      font-weight: 600;
      font-size: 2.8383rem;
      margin-right: 0.681rem;
    }
    .price-details {
      font-weight: 300;
      font-size: 1.1353rem;
    }
  }
  .benefits {
    margin-top: 1.4rem;
    padding: 0 4rem;
    text-align: left;
    display: grid;
    grid-template-columns: auto;
    font-weight: 300;
    font-size: 1.3rem;
    column-gap: 0.8rem;
    @include phone-down {
      grid-template-columns: auto;
    }
    .benefit {
      margin-top: 0.2rem;
      display: flex;
      align-items: flex-start;
      img {
        margin-right: 0.8rem;
        margin-top: 0.5rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payment_v2/SubscriptionDetails.vue